<template>
  <div class="sub-com-wrap">
    <div class="title">
      <div class="sep"></div>
      现有办税人员
    </div>

    <div class="content">
      <el-form :model="queryParams" class="add-form"
               ref="formRef" :rules="{}" :inline="true" label-width="70px">

        <el-form-item
            label="姓名"
            prop="ticName">
          <el-input
              v-model="queryParams.ticName"
              style="width: 200px;"
              clearable
              placeholder="请输入姓名"/>
        </el-form-item>

        <el-form-item
            label="身份类型"
            prop="roleType">
          <el-select
              v-model="queryParams.roleType"
              placeholder="请选择身份类型"
              clearable
              style="width: 200px;"
          >
            <el-option label="办税员" value="办税员"/>
            <el-option label="开票员" value="开票员"/>
            <el-option label="管理员" value="管理员"/>
          </el-select>
        </el-form-item>

        <el-form-item>
          <el-button type="primary" @click="queryData">查询</el-button>
        </el-form-item>
      </el-form>

      <el-table
          ref="tableRef"
          :data="showTableList"
          class="already-user-table"
          style="margin-top: 10px;"
          border
      >
        <el-table-column type="index" label="序号" fixed="left" align="center" width="60"/>

        <el-table-column label="姓名" align="center" prop="ticName" min-width="100"/>

        <el-table-column label="手机号码" align="center" prop="phone" min-width="120"/>

        <el-table-column label="身份类型" align="center" prop="roleType" min-width="120"/>

        <el-table-column label="关联状态" align="center" prop="associateStatus" min-width="120">
          <template #default="{row}">
            <span v-if="row.associateStatus">{{ row.associateStatus }}</span>
            <span v-else-if="row.isAuth == '是'">已启用</span>
          </template>
        </el-table-column>

        <el-table-column label="有效期止" align="center" prop="validTime" min-width="120"/>

        <el-table-column
            fixed="right"
            label="操作" align="center"
            min-width="120">
          <template #default="{row, $index}">

            <el-button
                v-if="row.ticName != 'admin'"
                size="small"
                link
                type="primary"
            >助信码
            </el-button>

            <el-button
                size="small"
                link
                type="primary"
            >管理
            </el-button>

            <el-button
                v-if="row.ticName != 'admin'"
                size="small"
                link
                type="primary"
                @click="deleteRow($index)"
            >删除
            </el-button>


          </template>
        </el-table-column>

      </el-table>
    </div>
  </div>
</template>

<script setup>
import {useTaxUserStore} from "./addTaxPina.js";

const store = useTaxUserStore()
const {userAnswer} = storeToRefs(store);
const queryParams = reactive({})

const staticUser = [
  {
    ticName: 'admin',
    phone: '13111111111',
    roleType: '管理员',
    associateStatus: '已启用',
    validTime: '长期',
  },
]

const showTableList = ref([])

onMounted(() => {
  queryData()
})

function queryData() {
  let resList = staticUser.concat(userAnswer.value).filter(f => (f.isAuth == '是' || f.associateStatus))
  if (queryParams.ticName) {
    resList = resList.filter(f => f.ticName.indexOf(queryParams.ticName) > -1)
  }
  if (queryParams.roleType) {
    resList = resList.filter(f => f.roleType == queryParams.roleType)
  }
  showTableList.value = resList
}

function deleteRow(index) {
  ElMessageBox.confirm("确认删除本条数据?", "提示")
      .then(() => {
        userAnswer.value.splice(index - 1, 1) // 默认的admin下标减去
        queryData()
      })
      .catch(() => {
      })
}
</script>

<style scoped lang="scss">
.sub-com-wrap {
  height: 100%;
  background-color: #FFFFFF;
  box-sizing: border-box;
  padding: 18px 20px;

  .title {
    font-size: 20px;
    line-height: 30px;
    color: #303133;
    font-weight: 700;
    display: flex;
    align-items: center;

    .sep {
      width: 5px;
      background-color: #409eff;
      margin-right: 8px;
      height: 20px;
      border-radius: 20%;
    }
  }

  .content {
    margin-top: 20px;

    :deep(.already-user-table) {
      .el-table__header {
        th.el-table__cell {
          background-color: #f9fafd;
        }
      }
    }
  }

}
</style>
